import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  ReferralLink,
  SvgIcon,
  ModalInfo,
  ModalInfoProps,
  Skeleton,
} from '@/components';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { profileSelectors } from '@/redux/selectors';
import { profileActions } from '@/redux/actions';
import styles from './YourReferralLinksModal.module.sass';

interface YourReferralLinksModalProps extends ModalInfoProps {
  onEdit: (reflink: any) => void;
  onAddNew: () => void;
}

const YourReferralLinksModal: FC<YourReferralLinksModalProps> = (props) => {
  const { isOpen, onClose, onEdit, onAddNew } = props;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { data: profileData, loading } = useAppSelector(
    profileSelectors.getProfileSlice,
  );

  useEffect(() => {
    dispatch(profileActions.fetchRefLinks());
  }, []);

  const renderReferralTable = () => {
    if (loading) {
      return <Skeleton className={styles.list} height="1.8rem" />;
    }
    if (profileData?.refLinksData && profileData.refLinksData.length) {
      return (
        <div className={styles.list}>
          {profileData.refLinksData.map((referral) => (
            <table key={referral.code}>
              <thead>
                <tr>
                  <th colSpan={4}>
                    {referral.title}
                    <button
                      type="button"
                      className={styles.edit}
                      onClick={() => onEdit(referral)}
                    >
                      <SvgIcon name="pencil" />
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ReferralLink value={referral.link} />
                  </td>
                  <td>
                    {t('translation.referral_lbl')}:{' '}
                    <b>{referral.referralsCount}</b>
                  </td>
                  <td>
                    <ul>
                      <li>
                        {t('translation.fee_percent_lbl')}:{' '}
                        <b>{referral.feePercent}%</b>
                      </li>
                      <li>
                        {t('translation.discount_lbl')}:{' '}
                        <b>{referral.discount}%</b>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>
                        {t('translation.earned_lbl')}:{' '}
                        <b>{referral.balance} USDT</b>
                      </li>
                      <li>
                        {t('translation.paid_lbl')}:{' '}
                        <b>{referral.withdrawals} USDT</b>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          ))}
        </div>
      );
    }
    return 'No referral links';
  };
  return (
    <ModalInfo
      isOpen={isOpen}
      title={t('translation.user_reflinks_label')}
      actions={
        <>
          <Button type="primary" corner="rect" onClick={onAddNew}>
            {t('translation.add_new')}
          </Button>
          <Button type="secondary" corner="rect" onClick={onClose}>
            {t('translation.cancel_btn')}
          </Button>
        </>
      }
      className={styles.modal}
      onClose={onClose}
    >
      <>{renderReferralTable()}</>
    </ModalInfo>
  );
};

export default YourReferralLinksModal;
